module.exports = __webpack_public_path__ + "img/normalLocale.37c676b5.png";